import React from 'react';

import { formatHours } from './formatHours';

// GRAVY-10073: yellow inline alert above the staffing worker list. Surfaces
// the cumulative duration of currently-selected shifts and reminds the
// admin to check the per-row "Hours This Week" column before exceeding 40.
//
// Pure visual component — the caller computes `shiftHours` from its own
// selected-shifts state shape, since the V2 wizard and the legacy
// CreateGigOrder wizard model selection differently.
//
// Styles are inline so the component is portable across both wizards
// without coupling to either's styled-components setup.

const FONT = "'Manrope', sans-serif";
const BG = '#FFF4D8';
const TEXT = '#BB8700';
const BORDER = '#FFCC7F';
const RADIUS = '8px';

type Props = {
  shiftHours: number;
};

export const OTRiskBanner: React.FC<Props> = ({ shiftHours }) => {
  if (!Number.isFinite(shiftHours) || shiftHours <= 0) return null;
  return (
    <div
      data-testid="ot-risk-banner"
      role="status"
      style={{
        backgroundColor: BG,
        color: TEXT,
        border: `1px solid ${BORDER}`,
        borderRadius: RADIUS,
        padding: '12px 16px',
        fontFamily: FONT,
        fontWeight: 400,
        fontSize: 16,
        lineHeight: '140%',
      }}
    >
      Assigning workers to this{' '}
      <strong style={{ fontWeight: 700 }}>{formatHours(shiftHours)} hr</strong>{' '}
      shift may result in{' '}
      <strong data-testid="ot-risk-banner-emphasis" style={{ fontWeight: 700 }}>
        overtime
      </strong>
      . Verify that each worker&apos;s weekly hours{' '}
      <strong style={{ fontWeight: 700 }}>won&apos;t exceed 40 hrs</strong>.
    </div>
  );
};

export default OTRiskBanner;
